import React, { useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import showClipboardAtom from "../recoil/clipboard/showClipboardAtom";

const CopyConfirm = (props) => {
  const [open, setOpen] = useState("");
  const [showClipboard, setShowClipboard] = useRecoilState(showClipboardAtom);
  let timeout = useRef();
  useEffect(() => {
    if (showClipboard) {
      setOpen("open");
      // clear previously set timeout to reset the 3 second timeout to display the notification.
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        setOpen("");
        setShowClipboard(false);
      }, 3000);
    }
  }, [showClipboard]);
  return (
    <div className={`copy-notification ${open}`}>
      <div className="message">
        Support details have been copied to the clipboard
      </div>
    </div>
  );
};

export default CopyConfirm;
